import { Button, InputAdornment, TextField, useTheme } from '@mui/material'
import { useRef, useState } from 'react'

import { EmailTwoTone } from '@mui/icons-material'

const RequestNewPassword = ({ updateEmail, setAlert }) => {
  const theme = useTheme()

  const [email, setEmail] = useState('')

  const requestReset = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL}/auth/password/reset?email=${email}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      const data = await response.json()
      if (data.success) {
        updateEmail(email)
        setAlert({
          text: data.message ?? 'Request sent successfully!',
          color: 'success',
        })
      } else {
        setAlert({
          text:
            data.message ??
            'Could not request password reset. Try again later.',
          color: 'error',
        })
      }
    } catch (error) {
      setAlert({
        text: 'Could not request password reset. Try again later.',
        color: 'error',
      })
      console.error('Could not request password reset', error)
    }
  }

  return (
    <>
      <TextField
        fullWidth
        label="Email address"
        type="email"
        name="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <EmailTwoTone sx={{ color: theme.palette.text.secondary }} />
              </InputAdornment>
            ),
          },
        }}
      />
      <Button
        id="verify-button"
        variant="contained"
        color="primary"
        disabled={!email.length}
        onClick={() => requestReset()}
      >
        Send reset link
      </Button>
    </>
  )
}

export default RequestNewPassword
